import { AxiosClient } from '@/app/shared/services';
import { toFormData } from '@/app/shared/services/helpers';

const state = {
    applications: {
        data: [],
        isLoading: false,
        isSuccess: false,
    },
    currentApplication:{
        package_name: "",
        keitaro_token: "",
        offers: [],
    },
    session: "",
};

const getters = {
    APPLICATIONS_IS_LOADING: (state) => state.applications.isLoading,
    APPLICATIONS_LOADING_SUCCESS: (state) => state.applications.isSuccess,
    CURRENT_APPLICATION: (state) => state.currentApplication,
    APPLICATIONS: (state) => state.applications.data,
};


const mutations = {
    SET_APPLICATIONS : (state, applications) => {
        state.applications.data = applications;
    },
    SET_APPLICATIONS_LOADING: (state, isLoading) => {
        state.applications.isLoading = isLoading;
    },
    SET_APPLICATIONS_LOADING_SUCCESS: (state, isSuccess) => {
        state.applications.isSuccess = isSuccess;
    },
    SET_CURRENT_APPLICATION: (state, application) => {
        state.currentApplication = application;
    },
    SET_APPLICATION_OFFERS: (state, offers) => {
        state.currentApplication.offers = offers;
    },
};


const actions = {
    GET_APPLICATIONS: (context, params) => {
        context.commit("SET_APPLICATIONS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/apps/get", { params })
                .then((data) => {
                    context.commit("SET_APPLICATIONS", data.data);
                    context.commit("SET_APPLICATIONS_LOADING_SUCCESS", true);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_APPLICATIONS_LOADING", false);
                });
        });
    },

    GET_APPLICATION_BY_ID: (context, app_id) => {
        context.commit("SET_APPLICATIONS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/apps/get/${app_id}`)
                .then((response) => {
                    context.commit("SET_CURRENT_APPLICATION", {
                        package_name: response.data.app.package_name,
                        keitaro_token: response.data.app.keitaro_token,
                        id: response.data.app.id,
                        offers: response.data.offers,
                    });
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_APPLICATIONS_LOADING", false);
                });
        });
    },

    DELETE_APPLICATION: (context, appId) => {
        context.commit("SET_APPLICATIONS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/apps/delete/${appId}`)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_APPLICATIONS_LOADING", false);
                });
        });
    },
    CREATE_APPLICATION: (context) => {
        context.commit("SET_APPLICATIONS_LOADING", true);
        return new Promise((resolve, reject) => {
            context.state.currentApplication.offers = context.state.currentApplication.offers.map((item, index) => {
                item.order = index;
                return item;
            });
            const form = toFormData(context.state.currentApplication);
            AxiosClient.post("/apps/create", form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_APPLICATIONS_LOADING", false);
                });
        });
    },
    UPDATE_APPLICATION: (context, appId) => {
        context.commit("SET_APPLICATIONS_LOADING", true);
        return new Promise((resolve, reject) => {
            context.state.currentApplication.offers = context.state.currentApplication.offers.map((item, index) => {
                item.order = index;
                return item;
            });
            const form = toFormData(context.state.currentApplication);
            AxiosClient.post(`/apps/update/${appId}`, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_APPLICATIONS_LOADING", false);
                });
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
